export default __webpack_public_path__ + "static/media/six.7468bab3.jpg";